function env<T = string | undefined>(variable: string | undefined, defaultValue?: T) {
  if (typeof variable === 'undefined') {
    return defaultValue;
  }
  return variable;
}

export const API_URL = env(process.env.REACT_APP_API_URL, 'https://lms.omegafuture.ru')!;

export const FAKE_USER_TOKEN = env(process.env.REACT_APP_API_TOKEN, 'add_token_in_env_file')!;
